import { render, staticRenderFns } from "./MypageTicketAccordionIconParts.vue?vue&type=template&id=c8832e5e&scoped=true"
import script from "./MypageTicketAccordionIconParts.vue?vue&type=script&lang=ts"
export * from "./MypageTicketAccordionIconParts.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketAccordionIconParts.vue?vue&type=style&index=0&id=c8832e5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8832e5e",
  null
  
)

export default component.exports